import React, { useEffect, Suspense } from 'react';
import {
    Routes,
    Route,
    Navigate,
    useLocation,
    useSearchParams
} from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { ENABLE_STUDENT_SIGNUP } from 'global/constants';
import { auth, signInWithCustomToken } from 'config/firebase';
import Loader from 'components/Loader';
import SignIn from 'pages/public/SignIn';
import SignUp from 'pages/public/SignUp';
import PasswordReset from 'pages/public/PasswordReset';
import Onboarding from 'pages/public/Onboarding';
import NotFound from 'pages/error/NotFound';
import Unauthorized from 'pages/error/Unauthorized';
import ServerError from 'pages/error/ServerError';
import { setAlert } from 'store/error';

function PublicRoutes() {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const { authenticated } = useAppSelector(state => state.user);
    const { status } = useAppSelector(state => state.error);
    const { organization } = useAppSelector(state => state.organization);

    const { pathname } = useLocation();

    const signInRedirectPaths = ['/test/:testId'];

    useEffect(() => {
        if (searchParams.get('auth_token')) {
            signInWithCustomToken(auth, searchParams.get('auth_token'))
                .catch(error => {
                    // console.log(error);
                });

            setSearchParams({});
        }
    }, []);

    if (status === 401) return <Unauthorized />;
    else if (status !== null) return <ServerError />;

    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route path='/' element={<Navigate to='/sign-in' />} />
                <Route path='/tests/digital-act' element={<Navigate to='/sign-in' />} />
                <Route path='/tests/digital-sat' element={<Navigate to='/sign-in' />} />
                <Route path='/tests/digital-psat' element={<Navigate to='/sign-in' />} />
                <Route path='/account' element={<Navigate to='/sign-in' />} />
                {ENABLE_STUDENT_SIGNUP.includes(organization.alias)
                ?   (authenticated ? <>
                        <Route path='*' element={<Onboarding />} />
                    </> : <>
                        <Route path='/sign-in' element={<SignIn />} />
                        <Route path='/sign-up' element={<SignUp />} />
                        <Route path='/onboarding' element={<Navigate to='/sign-in' />} />
                        <Route path='/password-reset' element={<PasswordReset />} />
                        {signInRedirectPaths.map(path => (
                            <Route key={path} path={path} element={
                                <Navigate
                                    to='/sign-in'
                                    replace
                                    state={{ referrer: pathname }}
                                />
                            }/>
                        ))}
                    </>)
                :   <>
                        <Route path='sign-in' element={<SignIn />} />
                        <Route path='password-reset' element={<PasswordReset />} />
                    </>
                }
                <Route path='*' element={<NotFound />} />
            </Routes>
        </Suspense>
    );
}

export default PublicRoutes;